<template>
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-start">
                <h3>Planos Internacionais</h3>
                <router-link v-if="$store.state.rotaAtual.split('.')[0] != 'IntRoutes'" :to="{ name: 'IntRoutes.Index' }" class="btn bg-danger btn-sm">Voltar para Rotas</router-link>
            </div>
        </div>
        <div class="card-body">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>